import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import FieldsetContainer from '@/components/shared/FieldsetContainer';
import { Button, TextInput } from '@/components/ui/daisy';
import { PickUnitInfo } from '@/models/Unit';

type UnitInlineFormFields = {
  name: string;
};

type UnitInlineFormProps = {
  onSubmit: (data: PickUnitInfo) => void;
  onCancel: () => void;
  isLoading?: boolean;
  order: number;
};

export default function UnitInlineForm({
  order,
  onSubmit,
  onCancel,
  isLoading,
}: UnitInlineFormProps) {
  const { t } = useTranslation('translation', {
    keyPrefix: 'courseLineForm.courseWorkspace.unitsTab',
  });

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<UnitInlineFormFields>({
    defaultValues: {
      name: '',
    },
  });

  const handleFormSubmit = (data: UnitInlineFormFields) => {
    onSubmit({
      name: data.name,
      order,
    });
  };

  return (
    <FieldsetContainer>
      <form
        className="flex flex-col gap-4"
        onSubmit={handleSubmit(handleFormSubmit)}
      >
        <TextInput.Fieldset
          label={t('unitName')}
          labelAlt={errors?.name?.message}
        >
          <TextInput
            type="text"
            placeholder={t('unitNamePlaceholder')}
            className="w-full"
            color={!errors?.name?.message ? 'default' : 'error'}
            {...register('name', { required: t('unitNameRequired') })}
          />
        </TextInput.Fieldset>
        <div className="flex justify-end gap-2">
          <Button
            type="button"
            className="grow bg-base-300"
            onClick={onCancel}
            disabled={isLoading}
          >
            {t('cancel')}
          </Button>
          <Button
            type="submit"
            color="secondary"
            className="grow"
            disabled={isLoading}
          >
            {t('save')}
          </Button>
        </div>
      </form>
    </FieldsetContainer>
  );
}
